module.exports = __webpack_public_path__ + "static/backdrop@1.5x-250b54981d144423a7115dff39c01f0d.png";